import React from 'react';
import classNames from 'classnames';
var blockClass = 'anchor';
var AnchorTarget = function AnchorTarget(_ref) {
  var id = _ref.id,
    className = _ref.className;
  var classes = classNames(blockClass, className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: blockClass + "__target"
  }));
};
export default AnchorTarget;